module.exports = __webpack_public_path__ + "static/media/aw3.520e1b61.png";